module.exports = __webpack_public_path__ + "908e4d2e/img/print-icon.d8dbbca5.svg";